import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  tracings: [],
  ptracing: [],
  wtracing: {}
}

const mutations = {
  SET_COMMENTS(state, payload) {
    state.comments = payload
  },
  SET_TRACINGS(state, payload) {
    state.tracings = payload
  },
  SET_PTRACING(state, payload) {
    state.ptracing = payload
  },
  SET_WTRACING(state, payload) {
    state.wtracing = payload
  },
  ADD_TRACING(state, payload) {
    state.ptracing.push(payload)
  },
  API_FAILURE(state, payload) {
    throw {
      error: true,
      payload: payload.body
    }
  }
}

const actions = {
  tracingList: (context, id) => {
    return Vue.http.get(`${env.API}/api/tracing`)
      .then((response) => {
        context.commit('SET_TRACINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getTracingById: (context, id) => {
    return Vue.http.get(`${env.API}/api/tracing/${id}`)
      .then((response) => {
        // context.commit('SET_TRACINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getTracingByPlan: (context, id) => {
    return Vue.http.get(`${env.API}/api/tracing/by-id-plan/${id}`)
      .then((response) => {
        context.commit('SET_PTRACING', response.body.message)        
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  commentsById: (context, id) => {
    return Vue.http.get(`${env.API}/api/tracing/comments?${id}`)    
      .then((response) => {        
        context.commit('SET_COMMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addComment: (context, data) => {
    return Vue.http.post(`${env.API}/api/tracing/comments`, data)    
      .then((response) => {        
        context.commit('ADD_COMMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getTracingByWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/tracing/by-week`, data)
      .then((response) => {
        context.commit('SET_WTRACING', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createTracing: (context, data) => {
    return Vue.http.post(`${env.API}/api/tracing`, data)
      .then((response) => {
        context.commit('SET_WTRACING', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deleteProblem: (context, id) => {
    return Vue.http.delete(`${env.API}/api/tracing/remove-problem/${id}`)
    .then((response) => {
      return response.body.success
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })  
  },
  closeTracing: (context, id) => {
    return Vue.http.delete(`${env.API}/api/tracing/${id}`)
      .then((response) => {
        // context.commit('SUB_TRACINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getByCreator: (context, data) => {
    const { plan, type } = data
    return Vue.http.get(`${env.API}/api/tracing/list-by-creator/${plan}/${type}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getByCreatorHistory: (context, data) => {
    const { userId, type } = data
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    return Vue.http.get(`${env.API}/api/tracing/list-by-creator-history/${userId}/${type}${query}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getHistoryDetail: (context, data) => {
    const { id, userId, type } = data
    return Vue.http.get(`${env.API}/api/tracing/get-cp-sd-detail/${id}/${userId}/${type}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getUserInformation: (context, id) => {
    return Vue.http.get(`${env.API}/api/tracing/user-information/${id}`)
      .then((response) => {
        return response.body.information
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  loadCommitmentsByUser: (context, data) => {
    const {
      userId,
      tracingId,
      userLeader
    } = data
    return Vue.http.get(`${env.API}/api/tracing/commitments/${userId}/${tracingId}/${userLeader}`)
      .then((response) => {
        return response.body.commitments
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getPersonalCommitments: (context, data) => {
    const {
      userId,
      tracingId,
      userLeader
    } = data
    return Vue.http.get(`${env.API}/api/tracing/personal-commitments/${userId}/${tracingId}/${userLeader}`)    
      .then((response) => { 
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createProblemOrOportunity: (context, data) => {
    return Vue.http.post(`${env.API}/api/tracing/new-problem`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  listProblems: (context, data) => {
    const { userId, tracingId, type, userLeader } = data
    return Vue.http.get(`${env.API}/api/tracing/list-problem/${userId}/${tracingId}/${type}/${userLeader}`)    
    .then((response) => {
      return response.body.list
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  finishTracing: (context, data) => {
    const { tracingId, userId, userLeader } = data
    return Vue.http.put(`${env.API}/api/tracing/close/${tracingId}/${userId}/${userLeader}`)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  generateMeetingsReport: (context, data) => {
    return Vue.http.post(`${env.API}/api/tracing/report-per-week`, data)    
      .then((response) => {
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getTracings: (state) => state.tracings,
  getPTracing: (state) => state.ptracing,
  getWTracing: (state) => state.wtracing
}

export const tracing = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tracing.js